type Props = {
  checked: boolean
  className?: string
}

export const RadioCheck = ({ checked, className }: Props) => {
  return (
    <div
      className={`flex justify-center items-center w-[16px] h-[16px] bg-custom-bg border border-solid rounded-3xl ${
        checked ? 'border-custom-secondary_border dark:border-custom-primary' : 'border-gray-300 dark:border-gray-300'
      } ${className}`}
    >
      {checked && (
        <div
          className={`flex w-[6px] h-[6px] rounded-3xl bg-custom-header dark:bg-custom-primary ${className}`}
        />
      )}
    </div>
  )
}
